export const revenueByClassReportHasRows = (csvText: string): boolean => {
  try {
    if (!csvText.trim()) {
      return false;
    }

    const lines = csvText
      .split(/\r?\n/)
      .filter((line) => line.trim().length > 0);
    const headerRowIndex = lines.findIndex(
      (line) => line.includes('Student Name') && line.includes('Amount'),
    );
    return headerRowIndex >= 0 && headerRowIndex < lines.length - 1;
  } catch (error) {
    console.error('Failed to check revenue-by-class report rows', { error });
    throw error;
  }
};
